import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { Button } from "antd";
import moment from "moment";

import { Editor } from "@toast-ui/react-editor";
import Swal from "sweetalert2";

import commentApi from "../../apis/Comment.api";
import longlifeApi from "../../apis/Longlife.api";
import CommentImageSlideGroup from "../channel/comment/CommentImageSlideGroup";

const ReplyComponent = ({
	comment,
	reply,
	addReplyShow,
	setAddReplyShow,
	getAdminCommentList,
	replyLoading,
	setReplyLoading,
	replyObj,
	setReplyObj,
	setReadLoading,
}) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const user = useSelector((state) => state.auth.user);

	const editorRef = useRef(null);
	const toolbarItems = [["link"]];

	const [replyEditShow, setReplyEditShow] = useState(false);

	const [editReply, setEditReply] = useState();

	useEffect(() => {
		setEditReply(reply);
	}, [reply]);

	/**
	 * 답글 수정 하기 -> 취소/완료 버튼 클릭
	 * @param e
	 * @returns {Promise<void>}
	 */
	const handleEditSubmit = async (e) => {
		let id = e.currentTarget.id;
		let contentByTag = editorRef.current?.getInstance().getHTML();
		setReadLoading(true);
		// 취소
		if (id === "cancel") {
			if (
				editReply?.content !== reply?.content ||
				editReply?.is_secret !== reply?.is_secret ||
				contentByTag?.length > 0
			) {
				Swal.fire({
					customClass: "alert-custom",
					text: `수정 중인 내용이 있습니다.\n그래도 취소하시겠습니까?`,
					showCancelButton: true,
					confirmButtonText: "확인",
					cancelButtonText: "취소",
				}).then(async (result) => {
					if (result.isConfirmed) {
						setReplyEditShow(false);
						setEditReply({
							...reply,
						});
					}
				});
			} else {
				setReplyEditShow(false);
				setEditReply({
					...reply,
				});
			}
			setReadLoading(false);
		}
		// 완료
		else if (id === "done") {
			if (contentByTag?.length > 0) {
				let res = null;
				setReplyLoading(true);
				if (comment?.category_type === "mission") {
					const param = {
						id: reply?.id,
						mission_id: comment?.board_id,
						verification_id: comment?.id,
						content: contentByTag ?? editReply?.content,
						created_by: user?.id,
						is_app: false,
						is_influencer: true,
					};
					res = await longlifeApi.registerReplyForApp(param);
					console.log(
						"handleEditSubmit :: param = ",
						param,
						"\n result = ",
						res.result
					);
				} else {
					const param = {
						id: reply?.id,
						comment_id: comment?.id,
						content: contentByTag ?? editReply?.content,
						is_secret: editReply?.is_secret,
						updated_by: user?.id,
						is_influencer: true,
						influencer_id: reduxChannel?.user_id,
					};
					res = await commentApi.adminUpdateReply(param);
				}
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 수정이 완료되었습니다.",
						confirmButtonText: "확인",
					}).then(() => {
						getAdminCommentList();
						setEditReply({
							...reply,
						});
						setReplyEditShow(false);
					});
				} else {
					getAdminCommentList();
					setReadLoading(false);
				}
				setReplyLoading(false);
			}
		}
	};

	/**
	 * 답글 삭제하기
	 * @returns {Promise<void>}
	 */
	const handleDeleteReply = async () => {
		setReadLoading(true);
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 댓글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let res = null;
				setReplyLoading(true);
				if (comment?.category_type === "mission") {
					const param = {
						id: reply?.id,
						userId: reply?.created_by,
						influencerId: user?.id,
						isApp: false,
					};
					res = await longlifeApi.deleteReplyByAdmin(param);
				} else {
					const param = {
						replyId: reply?.id,
						userId: user?.id,
					};
					res = await commentApi.adminDeleteReply(param);
				}
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "정상적으로 삭제가 완료되었습니다.",
						confirmButtonText: "확인",
					}).then(() => {
						getAdminCommentList();
					});
				} else {
					setReadLoading(false);
				}
				setReplyLoading(false);
			} else {
				setReadLoading(false);
			}
		});
	};

	const handleEditButton = () => {
		setReplyEditShow(!replyEditShow);
		const timer = setTimeout(() => {
			if (editorRef.current && editReply?.content) {
				editorRef.current?.getInstance().setHTML(editReply?.content);
			}
		}, 150);
		return () => {
			clearTimeout(timer);
		};
	};

	return (
		<>
			<img
				src={`
                ${
									reply?.is_influencer
										? `
                ${process.env.REACT_APP_S3_HOST}/image/together/profile_${reply?.created_by}.${reply?.influencer_profile_img_type}
                `
										: reply?.is_app
										? reply?.profile_img_type && Number(reply?.profile_url) > 0
											? `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/profile/${reply.created_by}-${reply.profile_url}.${reply.profile_img_type}`
											: `/assets/images/channel/basic.png`
										: reply?.profile_img_type
										? `${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${reply?.created_by}.${reply?.profile_img_type}`
										: `/assets/images/channel/basic.png`
								}
                `}
				onError={({ currentTarget }) => {
					currentTarget.onerror = null; // prevents looping
					// currentTarget.style.display = "none";
					currentTarget.src = `/assets/images/channel/basic.png`;
				}}
				alt={`채널 이미지`}
				className={`comment-img`}
			/>
			{!replyEditShow ? (
				<div className={`comment-div-each`}>
					<div className={`comment-div-each-row`}>
						{!reply?.is_influencer ? (
							<p className={`gray`}>
								{reply?.created_by_name ? reply?.created_by_name : reply?.phone}
							</p>
						) : (
							<p
								className={`gray ${
									user?.id === reply?.created_by ? "influencer-id" : ""
								}`}
							>
								{reply?.created_by_name}
							</p>
						)}
						<p className={`gray`}>ㆍ</p>
						<p className={`gray`}>
							{moment(moment(reply?.created_at), "YYYY.MM.DD").fromNow()}
						</p>
						{!!reply?.is_secret && (
							<>
								<p className={`gray`}>ㆍ</p>
								<p className={`secret`}>비밀댓글</p>
								<img
									src={`/assets/images/channel/secret.png`}
									alt={`비밀댓글`}
									style={{
										width: "0.9em",
										height: "0.9em",
									}}
								/>
							</>
						)}
					</div>
					<div
						className={`comment-div-each-row`}
						style={{
							flexDirection: "column",
							alignItems: "flex-start",
						}}
					>
						{!!reply?.imageList?.length && (
							<CommentImageSlideGroup
								imageList={reply?.imageList}
								type={"reply"}
							/>
						)}
						{reply?.content?.includes("<p>") ? (
							<div
								dangerouslySetInnerHTML={{
									__html: reply.content,
								}}
								style={{
									wordBreak: "break-all",
								}}
							/>
						) : (
							<p>{reply?.content}</p>
						)}
					</div>
					<div className={`comment-div-each-row`}>
						<button onClick={handleDeleteReply} disabled={replyLoading}>
							삭제
						</button>
						{!!reply?.is_influencer && (
							<button
								onClick={() => {
									handleEditButton();
								}}
								disabled={replyLoading}
							>
								수정
							</button>
						)}
						<button
							onClick={() => {
								setReplyObj({
									...replyObj,
									is_secret: reply?.is_secret,
								});
								setAddReplyShow(!addReplyShow);
							}}
							disabled={replyLoading}
						>
							답글달기
						</button>
						{/*<button>*/}
						{/*    답글 {comment?.replyDTOList?.length}개*/}
						{/*</button>*/}
					</div>
				</div>
			) : (
				<div className={`comment-div-each`}>
					{/*<Input.TextArea*/}
					{/*	className={`comment-textarea`}*/}
					{/*	type={`text`}*/}
					{/*	placeholder={`답글 내용을 작성해주세요`}*/}
					{/*	value={editReply?.content}*/}
					{/*	onChange={(e) =>*/}
					{/*		setEditReply({*/}
					{/*			...editReply,*/}
					{/*			content: e.target?.value,*/}
					{/*		})*/}
					{/*	}*/}
					{/*/>*/}
					<Editor
						ref={editorRef}
						initialEditType={"wysiwyg"} // wysiwyg & markdown
						initialValue={""} // 글 수정 시 사용
						// initialValue={contentTitle.content || ""} // 글 수정 시 사용
						previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
						hideModeSwitch={true}
						theme={""} // '' & 'dark'
						usageStatistics={false}
						toolbarItems={toolbarItems}
						useCommandShortcut={true}
						// plugins={[colorSyntax]}
						language="ko-KR"
						minHeight={"15em"}
						placeholder={"답글 내용을 작성해주세요"}
					/>
					<div className={`comment-textarea-footer edit-reply-component`}>
						<Button
							className={`reply-with-secret-edit`}
							onClick={() =>
								setEditReply({
									...editReply,
									is_secret: !editReply.is_secret,
								})
							}
							disabled={replyLoading}
						>
							<img
								src={`/assets/images/login/check${
									editReply.is_secret ? "-active" : ""
								}.png`}
								alt={`비밀글`}
								style={{
									height: "auto",
									width: "1.1em",
								}}
							/>
							{/*비밀글로 작성하기*/}
							비밀글
						</Button>
						<div className={`reply-edit-button-group`}>
							<Button
								onClick={handleEditSubmit}
								id={`cancel`}
								disabled={replyLoading}
							>
								취소
							</Button>
							<Button
								// disabled={!replyText?.length}
								onClick={handleEditSubmit}
								id={`done`}
								disabled={replyLoading}
							>
								완료
							</Button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};
export default ReplyComponent;
